import React, { useDeferredValue, useState } from "react";
import { Combobox, ComboboxButton, ComboboxInput, Label } from "@headlessui/react";
import { ChevronsUpDown } from "lucide-react";
import { filterItems, isNoResultOption, SelectListOptions, toVirtualOptions } from "./select/selectListOptions";
import { FIELD_CLASS, FIELD_LABEL_CLASS } from "./fieldClass";
export const Select = ({ items, value, onChange, title, inputRef }) => {
    const [search, setSearch] = useState("");
    const deferredSearch = useDeferredValue(search);
    // Looked up in items, not the filtered list, so the selected name still shows while searching.
    const selectedItem = items.find((item) => item.value === value);
    // Derived, not state — an effect lagged a render and flashed an empty list on first paint.
    const filteredList = filterItems(items, deferredSearch);
    return (<Combobox value={value} virtual={{ options: toVirtualOptions(filteredList), disabled: isNoResultOption }} onChange={(newValue) => {
            // HeadlessUI 2.2.9 bug: arrow key on the lone disabled sentinel sets index -1, and Enter commits undefined.
            if (newValue === undefined)
                return;
            setSearch("");
            onChange(newValue ?? "");
        }} immediate>
            <div className="relative mt-1">
                {title && <Label className={FIELD_LABEL_CLASS}>{title}</Label>}
                <div className="relative w-full rounded-xl text-left">
                    <ComboboxInput className={`${FIELD_CLASS} truncate pr-9`} displayValue={() => (search !== "" ? "" : (selectedItem?.name ?? ""))} onChange={(event) => setSearch(event.target.value)} ref={inputRef}/>

                    <div className="absolute inset-y-0 right-0 flex items-center pr-1.5">
                        <ComboboxButton className={"rounded-lg p-1 text-gray-400 hover:text-brand-600 cursor-pointer pressable focus-ring tap-target"}>
                            <ChevronsUpDown className="h-4 w-4" aria-hidden="true"/>
                        </ComboboxButton>
                    </div>
                </div>

                <SelectListOptions search={deferredSearch} setSearch={setSearch} items={items}/>
            </div>
        </Combobox>);
};
//# sourceMappingURL=select.jsx.map